module.exports = __webpack_public_path__ + "img/buyout-success.d73a95b2.svg";